module.exports = __webpack_public_path__ + "assets/img/22_266.eb99243f.jpg";